var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdasIntelligenceHorizontalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.28 23.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #1f6feb;\n      }\n\n      .st1 {\n        fill: #2c3d4d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.1,
    cy: 12.63,
    r: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.59,6.39c-.43,0-.85-.08-1.23-.22v9.18c0,1.68-1.19,2.54-2.21,2.78-1.02.23-2.47-.03-3.2-1.54l-6.19-12.8c-.88-1.82-2.68-2.96-4.7-2.97-.01,0-.02,0-.04,0-2.01,0-3.81,1.11-4.7,2.91L0,20.33h2.79l7.75-15.49c.48-.96,1.4-1.53,2.47-1.53,0,0,.01,0,.02,0,1.08,0,2,.59,2.47,1.56l6.19,12.8c1.11,2.29,3.52,3.45,6.01,2.88,2.48-.57,4.15-2.66,4.15-5.21V6.16c-.39.15-.82.23-1.26.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30.59,
    cy: 2.74,
    r: 2.02
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.83,8.3h-1.57l2.87-7.25c.3-.76.86-1.05,1.72-1.05s1.4.29,1.69,1.05l2.76,7.25h-1.58l-2.48-6.56c-.07-.19-.2-.28-.4-.28s-.33.09-.41.28l-2.59,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.06.14c2.38,0,3.68,1.33,3.68,4.09s-1.28,4.07-3.68,4.07h-2.88c-.46,0-.68-.22-.68-.66V.81c0-.45.22-.66.68-.66h2.88ZM55.93,6.73c0,.11.05.14.16.14h1.97c1.58,0,2.25-.79,2.25-2.66s-.66-2.65-2.25-2.65h-1.97c-.11,0-.16.04-.16.15v5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.76,8.3h-1.57l2.87-7.25c.3-.76.86-1.05,1.72-1.05s1.4.29,1.69,1.05l2.76,7.25h-1.58l-2.48-6.56c-.07-.19-.2-.28-.4-.28s-.33.09-.41.28l-2.59,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.71.14v1.43h-4.18c-.74,0-1.06.4-1.06.97,0,.5.25.97,1.21.97h1.91c2.22,0,2.74,1.23,2.74,2.41,0,1.38-.74,2.39-2.6,2.39h-4.55v-1.43h4.59c.77,0,1.12-.42,1.12-1.02,0-.53-.28-1.02-1.28-1.02h-1.9c-2.18,0-2.68-1.22-2.68-2.36,0-1.35.73-2.35,2.54-2.35h4.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.78,
    cy: 5.55,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 66.7,
    cy: 5.55,
    r: 0.95
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.21,14.35c-.23,0-.44-.05-.64-.12v6.25h1.28v-6.25c-.2.08-.41.12-.64.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45.21,
    cy: 12.59,
    r: 0.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.46,14.35c-.23,0-.44-.05-.64-.12v6.25h1.28v-6.25c-.2.08-.41.12-.64.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 74.46,
    cy: 12.59,
    r: 0.95
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.26,11.52c-.23,0-.45-.05-.65-.13v9.09h1.28v-9.08c-.2.08-.41.12-.63.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.36,11.52c-.23,0-.45-.05-.65-.13v9.09h1.28v-9.08c-.2.08-.41.12-.63.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.04,15.33v-1.24h-1.77v-1.49c-.19.07-.4.12-.62.12-.24,0-.47-.05-.68-.14v1.5h-.87v1.24h.87v2.95c0,1.67.57,2.2,1.89,2.2h1.15v-1.17h-.88c-.6,0-.86-.24-.86-.96v-3.03h1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,14.13c2.15,0,3.2,1.02,3.2,2.78v3.57h-1.29v-3.57c0-1-.58-1.55-1.91-1.55h-2.08c-.11,0-.16.06-.16.18v4.94h-1.28v-5.36c0-.75.25-.99.89-.99h2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.15,14.13c1.5,0,2.14.72,2.14,1.95s-.59,1.83-2.15,1.83h-3.02v.46c0,.51.28.88.97.88h3.89v1.24h-3.89c-1.59,0-2.21-.89-2.21-2.09v-2.16c0-1.2.63-2.09,2.21-2.09h2.06ZM61.12,16.91h2.98c.69,0,.94-.29.94-.76s-.28-.79-.9-.79h-2.04c-.7,0-.97.38-.97.88v.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.89,14.13c1.52,0,2.33.89,2.33,2.72v3.66c0,1.8-.63,2.51-2.41,2.51h-3.78v-1.23h3.63c.95,0,1.26-.37,1.26-1.29v-.29h-2.8c-1.7,0-2.75-1-2.75-3.06s1.06-3.03,2.75-3.03h1.76ZM79.25,19.06h2.68v-2.23c0-1.03-.4-1.48-1.42-1.48h-1.26c-1.09,0-1.59.55-1.59,1.85s.49,1.85,1.59,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.66,14.13c1.5,0,2.14.72,2.14,1.95s-.59,1.83-2.15,1.83h-3.02v.46c0,.51.28.88.97.88h3.89v1.24h-3.89c-1.59,0-2.21-.89-2.21-2.09v-2.16c0-1.2.63-2.09,2.21-2.09h2.06ZM85.63,16.91h2.98c.69,0,.94-.29.94-.76s-.28-.79-.9-.79h-2.04c-.7,0-.97.38-.97.88v.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.39,14.13c2.15,0,3.2,1.02,3.2,2.78v3.57h-1.29v-3.57c0-1-.58-1.55-1.91-1.55h-2.08c-.11,0-.16.06-.16.18v4.94h-1.28v-5.36c0-.75.25-.99.89-.99h2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.62,14.13v1.23h-3.15c-1.11,0-1.59.58-1.59,1.95s.48,1.94,1.59,1.94h3.15v1.24h-3.27c-1.7,0-2.75-1.03-2.75-3.18s1.06-3.18,2.75-3.18h3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.79,14.13c1.5,0,2.14.72,2.14,1.95s-.59,1.83-2.15,1.83h-3.02v.46c0,.51.28.88.97.88h3.89v1.24h-3.89c-1.59,0-2.21-.89-2.21-2.09v-2.16c0-1.2.63-2.09,2.21-2.09h2.06ZM107.76,16.91h2.98c.69,0,.94-.29.94-.76s-.28-.79-.9-.79h-2.04c-.7,0-.97.38-.97.88v.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdasIntelligenceHorizontalLogo);
export default __webpack_public_path__ + "static/media/adas-intelligence-horizontal-logo.4d8b9bace447b3dd0c872e542b96eb4c.svg";
export { ForwardRef as ReactComponent };